export const navigation = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
  },
  {
    title: true,
    name: 'Registration',
  },
  {
    name: 'Registrasi',
    url: '/registration',
    icon: 'icon-book-open',
    children: [
      {
        name: 'Daftar Registrasi',
        url: '/registration',
        icon: 'icon-people',
      },
      {
        name: 'Laporan',
        url: '/registration/report',
        icon: 'icon-docs',
      },
      {
        name: 'Resume Registrasi',
        url: '/registration/resume',
        icon: 'icon-calculator',
      },
      {
        name: 'Grafik',
        url: '/registration/graph',
        icon: 'icon-pie-chart',
      },
    ],
  },
  {
    name: 'Pembayaran',
    url: '/payment',
    icon: 'icon-wallet',
    children: [
      {
        name: 'All Payment',
        url: '/payment/all-payment',
        icon: 'icon-credit-card',
      },
      {
        name: 'Payment Perp.',
        url: '/payment/all-payment-retention',
        icon: 'icon-credit-card',
      },
      {
        name: 'Manual Confirm',
        url: '/payment/manual-confirm',
        icon: 'icon-bag',
      },
    ],
  },
  {
    name: 'Check-in',
    url: '/checkin',
    icon: 'icon-directions',
    children: [
      {
        name: 'Siswa Checkin',
        url: '/checkin/student',
        icon: 'icon-login',
      },
      {
        name: 'Scan QR Toolkit',
        url: '/checkin/scan-qr',
        icon: 'icon-camera',
        permission: 'student_toolkit.update',
      },
      {
        name: 'Kasir',
        url: '/cashier',
        icon: 'icon-wallet',
        permission: 'cashpay.use',
      },
      {
        name: 'Cashpay',
        url: '/checkin/cashpay',
        icon: 'icon-calculator',
      },
    ],
  },

  {
    title: true,
    name: 'Academic',
  },
  {
    name: 'Siswa',
    url: '/academic/student',
    icon: 'icon-graduation',
    children: [
      {
        name: 'Daftar Siswa',
        url: '/academic/student/student-list',
        icon: 'icon-people',
      },
      {
        name: 'Daftar Rombongan',
        url: '/academic/student/rombongan',
        icon: 'icon-people',
      },
      {
        name: 'Daftar Cicilan',
        url: '/academic/student/cicilan',
        icon: 'icon-wallet',
      },
      {
        name: 'Daftar Perpanjangan',
        url: '/academic/student/retention',
        icon: 'icon-people',
      },
      {
        name: 'Placement Test',
        url: '/academic/student/placement-test',
        icon: 'icon-location-pin',
      },
      {
        name: 'Pemetaan Kelas',
        url: '/academic/student/class-mapping',
        icon: 'icon-direction',
      },
      {
        name: 'Resume',
        url: '/academic/student/student-resume',
        icon: 'icon-calculator',
      },
    ],
  },
  {
    name: 'Kelas',
    url: '/academic/class',
    icon: 'icon-frame',
    children: [
      {
        name: 'Kelas Utama',
        url: '/academic/class/main-class',
        icon: 'icon-pin',
      },
      {
        name: 'Kelas Camp',
        url: '/academic/class/camp-class',
        icon: 'icon-home',
      },
      {
        name: 'Ruang Kelas',
        url: '/academic/class/class-room',
        icon: 'icon-grid',
      },
      {
        name: 'Naik Kelas',
        url: '/academic/class/change-class',
        icon: 'icon-arrow-up-circle',
      },
    ],
  },
  {
    name: 'Guru',
    url: '/academic/teacher',
    icon: 'icon-eyeglass',
  },
  {
    name: 'Laporan',
    url: '/academic/report',
    icon: 'icon-docs',
    children: [
      {
        name: 'Pembagian Kelas',
        url: '/academic/report/class-placement',
        icon: 'icon-list',
      },
      {
        name: 'Nilai Mingguan',
        url: '/academic/report/student-weekly',
        icon: 'icon-calculator',
      },
      {
        name: 'Sertifikat',
        url: '/academic/report/student-certificate',
        icon: 'icon-badge',
      },
    ],
  },

  {
    name: 'Camp',
    title: true,
  },
  {
    name: 'Master',
    url: '/camp/master',
    icon: 'icon-layers',
    children: [
      {
        name: 'Master Camp',
        url: '/camp/master/camp',
        icon: 'icon-home',
      },
      {
        name: 'Vendor Laundry',
        url: '/camp/master/laundry-vendor',
        icon: 'icon-drop',
      },
    ],
  },
  {
    name: 'Mapping',
    url: '/camp/mapping',
    icon: 'icon-direction',
    children: [
      {
        name: 'Automapping',
        url: '/camp/mapping/auto',
        icon: 'icon-screen-desktop',
      },
      // {
      //   name: 'Check-in mapping',
      //   url: '/camp/mapping/checkin',
      //   icon: 'icon-directions',
      // },
    ],
  },
  {
    name: 'Resume Camp',
    url: '/camp/resume',
    icon: 'icon-calculator',
    permission: 'camp_resume.read',
  },
  {
    name: 'Laporan',
    url: '/camp/report',
    icon: 'icon-docs',
    children: [
      {
        name: 'Occupancy',
        url: '/camp/report/occupancy',
        icon: 'icon-grid',
      },
      {
        name: 'Payment',
        url: '/camp/report/payment',
        icon: 'icon-wallet',
      },
    ],
  },
  {
    name: 'Print-out',
    url: '/camp/print-out',
    icon: 'icon-printer',
    children: [
      {
        name: 'Laundry',
        url: '/camp/print-out/laundry',
        icon: 'icon-drop',
      },
      {
        name: 'Catering',
        url: '/camp/print-out/catering',
        icon: 'icon-cup',
      },
    ],
  },
  {
    name: 'Dashboard',
    url: '/camp/dashboard',
    icon: 'icon-speedometer',
  },
  {
    name: 'Misc',
    title: true,
  },
  {
    name: 'Leads',
    url: '/leads',
    icon: 'icon-rocket',
  },
  {
    name: 'Penjemputan',
    url: '/penjemputan',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Daftar Jemputan',
        url: '/penjemputan',
        icon: 'icon-list',
      },
    ],
  },
  {
    divider: true,
  },
  {
    title: true,
    name: 'Admin',
  },
  {
    name: 'Ac Room',
    url: '/ac-rooms',
    icon: 'icon-home',
  },
  {
    name: 'Kursus',
    url: '/admin/course',
    icon: 'icon-drawer',
    children: [
      {
        name: 'Penjemputan',
        url: '/admin/pickup',
        icon: 'icon-rocket',
      },
      {
        name: 'Biaya Admin',
        url: '/admin/admin-fee',
        icon: 'icon-wallet',
      },
      {
        name: 'Jenjang',
        url: '/admin/course/education',
        icon: 'icon-graduation',
      },
      {
        name: 'Periode',
        url: '/admin/course/periode',
        icon: 'icon-hourglass',
      },
      {
        name: 'Quota',
        url: '/admin/course/quota',
        icon: 'icon-lock',
      },
      {
        name: 'Grade',
        url: '/admin/course/grades',
        icon: 'icon-ghost',
      },
      {
        name: 'K. Paket',
        url: '/admin/course/course-category',
        icon: 'icon-layers',
      },
      {
        name: 'Paket',
        url: '/admin/course/package',
        icon: 'icon-handbag',
      },
      {
        name: 'Jam Meeting',
        url: '/admin/course/meet-hours',
        icon: 'icon-clock',
      },
    ],
  },
  {
    name: 'Template',
    url: '/admin/template',
    icon: 'icon-folder-alt',
    children: [
      {
        name: 'Email',
        url: '/admin/template/email',
        icon: 'icon-envelope',
      },
      {
        name: 'Pdf',
        url: '/admin/template/pdf',
        icon: 'icon-envelope',
      },
      {
        name: 'SMS',
        url: '/admin/template/sms',
        icon: 'icon-bubble',
      },
      {
        name: 'Whatsapp',
        url: '/admin/template/whatsapp',
        icon: 'fa fa-whatsapp',
      },
    ],
  },
  {
    name: 'Cabang',
    url: '/admin/branch',
    icon: 'icon-globe',
  },
  {
    name: 'Provinsi',
    url: '/admin/province',
    icon: 'icon-globe',
  },
  {
    name: 'Voucher',
    url: '/admin/voucher',
    icon: 'icon-diamond',
  },
  {
    name: 'Labels',
    url: '/admin/labels',
    icon: 'icon-tag',
    permission: 'label.read',
  },
  {
    name: 'User',
    url: '/admin/user',
    icon: 'icon-people',
  },
  {
    divider: true,
  },
  {
    title: true,
    name: 'Settings',
  },
  {
    name: 'Settings',
    url: '/settings',
    icon: 'icon-settings',
    children: [
      {
        name: 'Account',
        url: '/settings/account',
        icon: 'icon-user',
      },
      {
        name: 'Theme Preference',
        url: '/settings/theme-preference',
        icon: 'icon-magic-wand',
      },
    ],
  },
];
